import { FC, useEffect } from 'react'
import cx from 'classnames'

import {
  updateIntercomDefault,
  updateIntercomForBottomToolbar,
} from 'common/components/Intercom'

type Props = {
  className?: string
}

const BottomToolbar: FC<Props> = ({ children, className }) => {
  useEffect(() => {
    updateIntercomForBottomToolbar()
    return () => updateIntercomDefault()
  }, [])

  return (
    <div
      className={cx(
        'sticky bottom-0 py-4 px-6 bg-white flex shadow-top',
        className
      )}
    >
      {children}
    </div>
  )
}

export default BottomToolbar
